import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";
import JwtService from "@/core/services/JwtService";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/dashboard",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/views/Dashboard.vue"),
      },
      {
        path: "/merchants/chargebacks",
        name: "chargebacks",
        component: () => import("@/components/page-layouts/Chargebacks.vue"),
        children: [
          {
            path: "incoming",
            name: "chargebacks-incoming",
            component: () =>
              import("@/views/merchants/chargebacks/Incoming.vue"),
          },
          {
            path: "incoming/details/:id",
            name: "chargebacks-incoming-details",
            component: () =>
              import("@/views/merchants/chargebacks/IncomingDetails.vue"),
          },
          {
            path: "responded",
            name: "chargebacks-responded",
            component: () =>
              import("@/views/merchants/chargebacks/Responded.vue"),
          },
          {
            path: "queue",
            name: "chargebacks-queue",
            component: () => import("@/views/merchants/chargebacks/Queue.vue"),
          },
          {
            path: "automation",
            name: "chargebacks-automation",
            component: () =>
              import("@/views/merchants/chargebacks/Automation.vue"),
          },
          {
            path: "insights",
            name: "chargebacks-insights",
            component: () =>
              import("@/views/merchants/chargebacks/Insights.vue"),
          },
          {
            path: "reports",
            name: "chargebacks-reports",
            component: () =>
              import("@/views/merchants/chargebacks/Reports.vue"),
          },
          {
            path: "reasons",
            name: "chargebacks-reasons",
            component: () =>
              import("@/views/merchants/chargebacks/Reasons.vue"),
          },
        ],
      },
      {
        path: "/merchants/prevention",
        name: "prevention",
        component: () => import("@/components/page-layouts/Prevention.vue"),
        children: [
          {
            path: "ethoca",
            name: "prevention-ethoca",
            component: () => import("@/views/merchants/prevention/Ethoca.vue"),
          },
          {
            path: "verifi",
            name: "prevention-verifi",
            component: () => import("@/views/merchants/prevention/Verifi.vue"),
          },
          {
            path: "rdr",
            name: "prevention-rdr",
            component: () => import("@/views/merchants/prevention/RdR.vue"),
          },
          {
            path: "geospy",
            name: "prevention-geospy",
            component: () => import("@/views/merchants/prevention/GeoSpy.vue"),
          },
          {
            path: "ordertection",
            name: "prevention-ordertection",
            component: () =>
              import("@/views/merchants/prevention/OrderTection.vue"),
          },
          {
            path: "fraudbot",
            name: "prevention-fraudbot",
            component: () =>
              import("@/views/merchants/prevention/FraudBot.vue"),
          },
          {
            path: "clarity",
            name: "prevention-clarity",
            component: () => import("@/views/merchants/prevention/Clarity.vue"),
          },
          {
            path: "orderinsight",
            name: "prevention-orderinsight",
            component: () =>
              import("@/views/merchants/prevention/OrderInsight.vue"),
          },
        ],
      },
      {
        path: "/ibos",
        name: "ibos",
        component: () => import("@/components/page-layouts/Ibos.vue"),
        children: [
          {
            path: "offers",
            name: "ibos-offers",
            component: () => import("@/views/merchants/prevention/Ethoca.vue"),
          },
          {
            path: "campaigns",
            name: "ibos-campaigns",
            component: () => import("@/views/merchants/prevention/Ethoca.vue"),
          }, {
            path: "landing-pages",
            name: "ibos-landing-pages",
            component: () => import("@/views/merchants/prevention/Ethoca.vue"),
          },
        ],
      },
      {
        path: "/merchants/connections",
        name: "connections",
        component: () => import("@/components/page-layouts/Connections.vue"),
        children: [
          {
            path: "apis",
            name: "connections-apis",
            component: () => import("@/views/merchants/connections/Apis.vue"),
          },
          {
            path: "gateways",
            name: "connections-gateways",
            component: () =>
              import("@/views/merchants/connections/Gateways.vue"),
          },
          {
            path: "processors",
            name: "connections-processors",
            component: () =>
              import("@/views/merchants/connections/Processors.vue"),
          },
          {
            path: "crms",
            name: "connections-crms",
            component: () => import("@/views/merchants/connections/CRMs.vue"),
          },
        ],
      },
      {
        path: "/merchants",
        name: "merchants",
        component: () => import("@/components/page-layouts/Merchants.vue"),
        children: [
          {
            path: "accounts",
            name: "merchants-accounts",
            component: () => import("@/views/merchants/Accounts.vue"),
          },
          {
            path: "accounts/details/:id",
            name: "merchants-details",
            component: () => import("@/views/merchants/accounts/Details.vue"),
            children: [
              {
                path: "overview",
                name: "accounts-overview",
                component: () =>
                  import("@/views/merchants/accounts/Overview.vue"),
              },
              {
                path: "portals",
                name: "accounts-portals",
                component: () =>
                  import("@/views/merchants/accounts/Portals.vue"),
              },
              {
                path: "apis",
                name: "accounts-apis",
                component: () => import("@/views/merchants/accounts/Apis.vue"),
              },
              {
                path: "transactions",
                name: "accounts-transactions",
                component: () =>
                  import("@/views/merchants/accounts/Transactions.vue"),
              },
              {
                path: "activity",
                name: "accounts-activity",
                component: () =>
                  import("@/views/merchants/accounts/Activity.vue"),
              },
              {
                path: "products",
                name: "accounts-products",
                component: () =>
                  import("@/views/merchants/accounts/Products.vue"),
              },
              {
                path: "checkout",
                name: "accounts-checkout",
                component: () =>
                  import("@/views/merchants/accounts/Checkout.vue"),
              },
              {
                path: "files",
                name: "accounts-files",
                component: () => import("@/views/merchants/accounts/Files.vue"),
              },
              {
                path: "tasks",
                name: "accounts-tasks",
                component: () => import("@/views/merchants/accounts/Tasks.vue"),
              },
              {
                path: "folders",
                name: "accounts-folders",
                component: () =>
                  import("@/views/merchants/accounts/Folders.vue"),
              },
              {
                path: "support",
                name: "accounts-support",
                component: () =>
                  import("@/views/merchants/accounts/Support.vue"),
              },
            ],
          },
          {
            path: "queue",
            name: "merchants-queue",
            component: () => import("@/views/merchants/Queue.vue"),
          },
          {
            path: "insights",
            name: "merchants-insights",
            component: () => import("@/views/merchants/Insights.vue"),
          },
          {
            path: "reports",
            name: "merchants-reports",
            component: () => import("@/views/merchants/Reports.vue"),
          },
          {
            path: "tasks",
            name: "merchants-tasks",
            component: () => import("@/views/merchants/Tasks.vue"),
          }, {
            path: "applications",
            name: "merchants-applications",
            component: () => import("@/views/merchants/accounts/Applications.vue"),
          },
          {
            path: "applications/details/:id",
            name: "applications-details",
            component: () => import("@/views/merchants/accounts/ApplicationDetails.vue"),
          },
        ],
      },
      {
        path: "/merchants/transactions",
        name: "transactions",
        component: () => import("@/views/merchants/Transactions.vue"),
        children: [
          {
            path: "sales",
            name: "transactions-sales",
            component: () => import("@/views/merchants/transactions/Sales.vue"),
          },
          {
            path: "refunds",
            name: "transactions-refunds",
            component: () =>
              import("@/views/merchants/transactions/Refunds.vue"),
          },
          {
            path: "subscriptions",
            name: "transactions-subscriptions",
            component: () =>
              import("@/views/merchants/transactions/Subscriptions.vue"),
          },
        ],
      },
      {
        path: "/admin",
        name: "admin",
        component: () => import("@/components/page-layouts/Admin.vue"),
        children: [
          {
            path: "orders",
            name: "admin-orders",
            component: () => import("@/views/admin/Orders.vue"),
          },
          {
            path: "groups",
            name: "admin-groups",
            component: () => import("@/views/admin/Groups.vue"),
          },
          {
            path: "templates",
            name: "admin-templates",
            component: () => import("@/views/admin/Templates.vue"),
          },
          {
            path: "users",
            name: "admin-users",
            component: () => import("@/views/admin/Users.vue"),
          },
          {
            path: "advertiser-applications",
            name: "admin-advertiser-applications",
            component: () => import("@/views/admin/AdvertiserApplications.vue"),
          },          {
            path: "main-applications",
            name: "admin-main-applications",
            component: () => import("@/views/admin/MainApplications.vue"),
          },
          {
            path: "tasklist",
            name: "admin-tasklist",
            component: () => import("@/views/admin/TaskList.vue"),
          },
          {
            path: "settings",
            name: "admin-settings",
            component: () => import("@/views/admin/Settings.vue"),
          },
          {
            path: "referral",
            name: "admin-referral",
            component: () => import("@/views/Referral.vue"),
          },
        ],
      },
      {
        path: "/calendar",
        name: "demo-calendar",
        component: () => import("@/views/apps/Calendar.vue"),
      },
      {
        path: "/chat/private-chat",
        name: "apps-private-chat",
        component: () => import("@/views/chat/Chat.vue"),
      },
      {
        path: "/chat/group-chat",
        name: "apps-group-chat",
        component: () => import("@/views/chat/Chat.vue"),
      },
      {
        path: "/chat/drawer-chat",
        name: "apps-drawer-chat",
        component: () => import("@/views/chat/DrawerChat.vue"),
      },
      {
        path: "/crafted/modals/general/invite-friends",
        name: "modals-general-invite-friends",
        component: () =>
          import("@/views/crafted/modals/general/InviteFriends.vue"),
      },
      {
        path: "/crafted/modals/general/view-user",
        name: "modals-general-view-user",
        component: () => import("@/views/crafted/modals/general/ViewUsers.vue"),
      },
      {
        // the account setup page.
        path: "/welcome",
        name: "welcome",
        component: () => import("@/views/Welcome.vue"),
      },
      {
        // the account setup page.
        path: "/dailyprep",
        name: "dailyprep",
        component: () => import("@/views/DailyPrep.vue"),
      },
      {
        path: "/purchases",
        name: "purchases",
        component: () => import("@/components/page-layouts/Admin.vue"),
        children: [
          {
            path: "consumer-purchases",
            name: "purchases-consumers",
            component: () => import("@/views/consumers/ConsumerPurchases.vue"),
          },
          {
            path: "lookup-merchant",
            name: "purchases-lookup-merchant",
            component: () => import("@/views/consumers/LookupMerchant.vue"),
          },
          {
            path: "wallets",
            name: "purchases-wallets",
            component: () => import("@/views/consumers/MyWallets.vue"),
          },
          {
            path: "banks",
            name: "purchases-banks",
            component: () => import("@/views/consumers/MyBanks.vue"),
          },
          {
            path: "merchant-protection",
            name: "purchases-merchant-protection",
            component: () =>
              import("@/views/consumers/MerchantProtectionExtension.vue"),
          },
        ],
      },
      {
        // the account setup page.
        path: "/welcome",
        name: "welcome",
        component: () => import("@/views/Welcome.vue"),
      },
      {
        // helpful links page.
        path: "/helplinks",
        name: "helplinks",
        component: () => import("@/views/HelpfulLinks.vue"),
      },

      {
        // helpful links page.
        path: "/get-started",
        name: "getstarted",
        component: () => import("@/views/GettingStarted.vue"),
      },
      {
        path: "/apps/customers/customers-listing",
        name: "apps-customers-listing",
        component: () => import("@/views/apps/customers/CustomersListing.vue"),
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/components/page-layouts/Auth.vue"),
    children: [
      {
        path: "/sign-in",
        name: "sign-in",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/SignIn.vue"),
      },
      {
        path: "/sign-up",
        name: "sign-up",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/SignUp.vue"),
      },
      {
        path: "/password-reset",
        name: "password-reset",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/PasswordReset.vue"),
      },
      {
        path: "/reset-modal",
        name: "reset-modal",
        component: () =>
          import("@/views/crafted/modals/forms/CreateApiKey.vue"),
      },
    ],
  },
  {
    // payment success page
    path: "/payment_success/:paymentid",
    name: "payment_success",
    component: () => import("@/views/PaymentSuccess.vue"),
  },
  {
    // the 404 route, when none of the above matches
    path: "/404",
    name: "404",
    component: () => import("@/views/crafted/authentication/Error404.vue"),
  },
  {
    path: "/500",
    name: "500",
    component: () => import("@/views/crafted/authentication/Error500.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
  {
    // helpful links page.
    path: "/realestate",
    name: "realestate",
    component: () => import("@/views/RealEstate.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to) => {
  if (to.name !== "demo-calendar") {
    if (
      !store.getters.isUserAuthenticated &&
      to.name !== "sign-in" &&
      to.name !== "sign-up"
    ) {
      return { name: "sign-in" };
    }
  }

  // reset config to initial state
  store.commit(Mutations.RESET_LAYOUT_CONFIG);

  store.dispatch(Actions.VERIFY_AUTH, { token: JwtService.getToken() });

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

export default router;
